import { useTranslation } from 'react-i18next';

export const useUnitOfMeasureTranslation = ({
  unitOfMeasure,
  format = 'long',
}: {
  unitOfMeasure?: string | null;
  format?: 'long' | 'short';
}) => {
  const { t } = useTranslation();

  /* i18n - For translation key extraction (long format):
    t('common:unitOfMeasure.BE')
    t('common:unitOfMeasure.BG')
    t('common:unitOfMeasure.BJ')
    t('common:unitOfMeasure.BO')
    t('common:unitOfMeasure.CA')
    t('common:unitOfMeasure.CMT')
    t('common:unitOfMeasure.COL')
    t('common:unitOfMeasure.CQ')
    t('common:unitOfMeasure.CS')
    t('common:unitOfMeasure.CT')
    t('common:unitOfMeasure.CU')
    t('common:unitOfMeasure.DAY')
    t('common:unitOfMeasure.EA')
    t('common:unitOfMeasure.GRM')
    t('common:unitOfMeasure.HUR')
    t('common:unitOfMeasure.KGM')
    t('common:unitOfMeasure.KMT')
    t('common:unitOfMeasure.LTR')
    t('common:unitOfMeasure.MLT')
    t('common:unitOfMeasure.MON')
    t('common:unitOfMeasure.MTK')
    t('common:unitOfMeasure.MTQ')
    t('common:unitOfMeasure.MTR')
    t('common:unitOfMeasure.PCK')
    t('common:unitOfMeasure.PF')
    t('common:unitOfMeasure.PR')
    t('common:unitOfMeasure.RO')
    t('common:unitOfMeasure.SET')
    t('common:unitOfMeasure.TNE')
    t('common:unitOfMeasure.TU')
    t('common:unitOfMeasure.WEE')

    i18n - For translation key extraction (short format):
    t('common:unitOfMeasure.abbreviated.CMT')
    t('common:unitOfMeasure.abbreviated.KGM')
    t('common:unitOfMeasure.abbreviated.KMT')
    t('common:unitOfMeasure.abbreviated.LTR')
    t('common:unitOfMeasure.abbreviated.MLT')
    t('common:unitOfMeasure.abbreviated.MTK')
    t('common:unitOfMeasure.abbreviated.MTQ')
    t('common:unitOfMeasure.abbreviated.MTR')
    t('common:unitOfMeasure.abbreviated.TNE')
    t('common:unitOfMeasure.abbreviated.default')
  */

  const key = unitOfMeasure || 'default';
  const translationPath =
    format === 'short' ? `common:unitOfMeasure.abbreviated.${key}` : `common:unitOfMeasure.${key}`;

  return t(translationPath, {
    // Falls back to the raw code (e.g. "XYZ") for units we don't have a translation for,
    // instead of leaking the untranslated i18n key.
    defaultValue: format === 'short' ? t('common:unitOfMeasure.abbreviated.default') : (unitOfMeasure ?? undefined),
  });
};
